<template>

<fragment>

    <div class="card-body-title">

		<core-gamename :game="item.game" class="card-body-title-text" :id="item.id" />

		<app-view-common-change 
            :date="item.rating.date" 
            :revisions="item.revisions" 
            :showDate="showDate" 
            :showChange="showStatus" 
            :datePrefix="datePrefix" 
            v-if="showStatus || showDate"
        />

	</div>

    <div class="card-body-comment" v-if="showComment && item.comment">

		<div ref="comment" v-html="item.comment.text"></div>

		<div class="card-body-comment-fade" v-if="longComment"></div>

	</div>

    <app-view-common-tags :field="field" :item="item" :filter="filter" :is-condensed="isCondensed" v-if="showTags" />

	<template v-if="field.ratings === 'enabled'">

		<app-view-common-insight_play-ratings v-for="rating in item.recent" :key="rating.user" :rating="rating" :game="item.game" :ready="true" />

	</template>

</fragment>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky'],

	data: function() {

		return {

			longComment: false

		}

	},

	watch: {

        longComment: function(n) {

            this.$emit('longcomment', n)

        },

		ready: function(n) {

			if (n) this.checkComment()

		},

		window: {

			handler: function(n, o) {

				if (n.width !== o.width) {

					this.checkComment()

				}

			},

			deep: true

		}

	},

	mounted: function() {

		this.checkComment()

	},

	computed: {

		datePrefix: function() {

			return (this.isUser || !this.item.rating.date) ? '' : 'Most recently rated on '

		},

        showTags: function() {

            return this.field.tags === 'enabled'

        },

        showStatus: function() {

            return this.field.status === 'enabled'

        },

        showDate: function() {

            return this.field.date === 'enabled' && this.isUser

        },

        showComment: function() {

            return this.field.comment === 'enabled' && this.isUser

        }

    },

	methods: {

		checkComment: function() {

			if (this.item.comment) {

				this.$nextTick(function() {
					if (this.$refs.comment) this.longComment = this.$refs.comment.offsetHeight > 90
				}.bind(this))

			}

		}

    }

}

</script>

<style scoped>

.game {
    padding-top: 10px;
}

.game-name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	min-width: 0;
    display: block;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
}

.field.is-condensed .game-name {
	font-size: 14px;
	line-height: 14px;
}

.is-desktop .game-name:hover {
	text-decoration: underline;
}

.card-body-title {
	margin-bottom: 10px;
	margin-top: 5px;
}

.card-body-title-wrapper {
	display: flex;
	flex-direction: row;
	width: calc(100% + 5px);
}

.card-body-title small {
	font-size: 12px;
	font-weight: 400;
	color: #666;
	display: block;
}

.card-body-title-text {
	font-size: 16px;
	line-height: 20px;
	font-weight: 500;
	color: #333;
	flex-grow: 1;
	flex-basis: 0;
	cursor: pointer;
}

.is-desktop .card-body-title-text:hover {
	text-decoration: underline;
}

.is-mobile .card-body-title-text {
	font-size: 14px;
}	

.card-body-comment {
	font-size: 14px;
	color: #666;
	line-height: 18px;
	max-height: 90px;
	overflow: hidden;
}

.is-mobile .card-body-comment {
	font-size: 14px;
	line-height: 16px;
}	

.card-body-comment.is-empty {
	opacity: 0.6;
}

.card-body-comment.is-empty:before {
	content: 'No comment written.'
}

.card-body-comment-fade {
	position: absolute; 
	bottom: 0; 
	left: 0;
	width: 100%; 
	text-align: center; 
	margin: 0; padding: 30px 0; 
	background-image: linear-gradient(to bottom, transparent, #fff);
}

.card.is-selected .card-body-comment-fade {
	background-image: linear-gradient(to bottom, transparent, #d4f2ff);
}

.card-body-comment-info {
	display: flex;
	flex-direction: row;
	margin-top: 10px;
}

.card-body-comment-info-date {
	font-size: 11px;
	font-weight: 300;
	color: #c7c7c7;
	flex-grow: 1;
}

.card-body-comment-info-more {
	flex-grow: 0;
	font-size: 12px;
	color: #4881bb;
	font-weight: 400;
	cursor: pointer;
}

.is-desktop .card-body-comment-info-more:hover {
	text-decoration: underline;
}

</style>